import { Component, OnInit, OnDestroy , Input ,SimpleChanges} from '@angular/core';
import { trigger,state,style,animate,transition } from '@angular/animations';

@Component({
  selector: 'app-slide-show',
  templateUrl: './slide-show.component.html',
  styleUrls: ['./slide-show.component.css'],
})
export class SlideShowComponent implements OnInit {
  @Input() slidenumber : number = 0;
  @Input() slidecolour : number = 0;
  defaultImage = 'assets/robohead.jpeg';

  DigitalMarketingSlides = [
    {
      heading: "AI DIGITAL MARKETING",
      description: "Harness the power of artificial intelligence to enhance your digital marketing strategies. Our AI-driven tools analyze consumer behavior, optimize ad placements, and personalize marketing messages to maximize your ROI. Stay ahead of the competition with cutting-edge technology.",
      benefits: [
        "Targeted marketing campaigns",
        "Real-time data analysis",
        "Enhanced customer engagement",
        "Increased conversion rates"
      ],
      image: 'assets/digitalmarketing/AIDIGITALMARKETING.jpg  ',
      currentBackground:'linear-gradient(to bottom right, rgba(17, 78, 76, 0.8) 10%, rgba(0, 0, 0, 0.9))'
    },
    {
      heading: "BRANDING",
      description: "Build a strong, recognizable brand that resonates with your audience. We offer comprehensive branding services, including logo design, brand messaging, and visual identity development. Let us help you create a brand that stands out and leaves a lasting impression.",
      benefits: [
        "Consistent brand identity",
        "Increased brand awareness",
        "Stronger customer loyalty",
        "Enhanced market positioning"
      ],
      image: 'assets/digitalmarketing/BRANDING.jpg',
      currentBackground:'linear-gradient(to bottom right, rgba(17, 78, 76, 0.8) 10%, rgba(0, 0, 0, 0.9))'
    },
    {
      heading: "LEAD GENERATION",
      description: "Generate high-quality leads with our expert lead generation services. We use advanced techniques and tools to identify and attract potential customers who are genuinely interested in your products or services. Boost your sales pipeline and grow your business.",
      benefits: [
        "Higher conversion rates",
        "Targeted prospecting",
        "Cost-effective marketing",
        "Sustainable business growth"
      ],
      image: 'assets/digitalmarketing/LEADGENERATION.jpg',
      currentBackground:'linear-gradient(to bottom right, rgba(17, 78, 76, 0.8) 10%, rgba(0, 0, 0, 0.9))'
    },
    {
      heading: "INFLUENCER MARKETING",
      description: "Leverage the power of influencers to promote your brand. Our influencer marketing strategies connect you with influencers who align with your brand values and can effectively reach your target audience. Increase your brand's visibility and credibility.",
      benefits: [
        "Increased brand exposure",
        "Authentic promotion",
        "Higher engagement rates",
        "Enhanced brand credibility"
      ],
      image: 'assets/digitalmarketing/influncemarketingwithoutline.jpg  ',
      currentBackground:'linear-gradient(to bottom right, rgba(17, 78, 76, 0.8) 10%, rgba(0, 0, 0, 0.9))'
    },
    {
      heading: "BUSINESS DEVELOPMENT",
      description: "Leverage the power of influencers to promote your brand. Our influencer marketing strategies connect you with influencers who align with your brand values and can effectively reach your target audience. Increase your brand's visibility and credibility.",
      benefits: [
        "Increased brand exposure",
        "Authentic promotion",
        "Higher engagement rates",
        "Enhanced brand credibility"
      ],
      image: 'assets/digitalmarketing/BUSINESSDEVELOPMENT.jpg  ',
      currentBackground:'linear-gradient(to bottom right, rgba(17, 78, 76, 0.8) 10%, rgba(0, 0, 0, 0.9))'
    },
    {
      heading: "CUSTOMER INTERACTION & SUPPORT",
      description: "This service is designed to manage customer relations and support through direct interaction channels, ensuring high-quality service and satisfaction.",
      benefits: [
        "Improved customer satisfaction",
        "Direct communication channels",
        "Efficient problem resolution",
        "Enhanced customer loyalty"
      ],
      image: 'assets/digitalmarketing/TELECALLINGANDCUSTOMERSUPPORT.jpg',
      currentBackground:'linear-gradient(to bottom right, rgba(17, 78, 76, 0.8) 10%, rgba(0, 0, 0, 0.9))'
    },
    {
      heading: "LEAD GENERATION",
      description: "Our Lead Generation services help you attract and convert potential customers into loyal clients. We use advanced techniques and tools to identify high-quality leads, nurture them through the sales funnel, and drive conversions. Our strategies are tailored to your business needs, ensuring effective and efficient lead generation.",
      benefits: [
        "High-Quality Leads: Attract leads that are more likely to convert into customers.",
        "Increased Sales Pipeline: Grow your sales opportunities with a steady stream of leads.",
        "Cost Efficiency: Reduce customer acquisition costs with targeted lead generation strategies.",
      ],
      image: 'assets/digitalmarketing/LEADGENERATION.jpg',
      currentBackground:'linear-gradient(to bottom right, rgba(17, 78, 76, 0.8) 10%, rgba(0, 0, 0, 0.9))'
    }
    
  ]
  TechnologySlides = [
    {
      heading: "WEBSITE DEVELOPMENT",
      description: "Create a seamless online experience with our website and app development services. We design and develop user-friendly websites and mobile apps that are tailored to your business needs. Ensure your online presence is professional, functional, and engaging.",
      benefits: [
        "Custom design solutions",
        "Mobile-friendly interfaces",
        "Enhanced user experience",
        "Increased customer satisfaction"
      ],
      image: 'assets/technology/WEBDEVELOPMENT.jpg',
      currentBackground:'linear-gradient(to bottom right, rgba(68, 34, 57, 0.9) 10%, rgba(0, 0, 0, 0.9))'
    },
    {
      heading: "APP DEVELOPMENT",
      description: "Create a seamless online experience with our website and app development services. We design and develop user-friendly websites and mobile apps that are tailored to your business needs. Ensure your online presence is professional, functional, and engaging.",
      benefits: [
        "Custom design solutions",
        "Mobile-friendly interfaces",
        "Enhanced user experience",
        "Increased customer satisfaction"
      ],
      image: 'assets/technology/APPDEVELOPMENT.jpg',
      currentBackground:'linear-gradient(to bottom right, rgba(68, 34, 57, 0.9) 10%, rgba(0, 0, 0, 0.9))'
    },
    {
      heading: "DATA ANALISATION & VISUALISTAION",
      description: "Unlock the potential of your data with our advanced Data Analytics services. We offer data collection, analysis, and visualization to help you gain actionable insights. Our solutions enable you to make informed decisions, optimize operations, and identify new opportunities.",
      benefits: [
        "Informed Decisions: Make strategic decisions based on comprehensive data analysis.",
        "Operational Efficiency: Optimize processes and improve efficiency.",
        "Growth Opportunities: Identify and capitalize on new business opportunities.",
        "Clarity: Enhance data comprehension with clear and concise visuals.",
        "Real-Time Insights: Access real-time data visualization for timely decisions."
      ],
      image: 'assets/technology/DAtaanalastandvisuvalaization.jpg',
      currentBackground:'linear-gradient(to bottom right, rgba(68, 34, 57, 0.9) 10%, rgba(0, 0, 0, 0.9))'
    },
  ]
  FintechSlides = [
    {
      heading: "RESCUE INESTMENT",
      description: "Turn around struggling businesses with our rescue investing services. We provide the necessary capital and strategic support to help businesses regain stability and profitability. Trust our expertise to guide your business back to success.",
      benefits: [
        "Financial stability",
        "Expert strategic guidance",
        "Improved business operations",
        "Sustainable growth"
      ],
      image: 'assets/fintech/rescueinvesting.jpg',
      currentBackground:'linear-gradient(to bottom right, rgba(70, 65, 33, 0.9) 10%, rgba(0, 0, 0, 0.9))'
    },
   
  ];
 
  
  currentIndex = 0;
  boxes : any = this.DigitalMarketingSlides;
  currentImage = "";
  currentText = "";
  currentHeading = "";
  currentBenefits = [];
  currentBackground = "";
  ngOnInit() {
    this.boxes = this.DigitalMarketingSlides;
    this.initialSlide(0);
  }
  ngOnChanges(changes: SimpleChanges){
    var CurrentValue =  changes?.['slidenumber'].currentValue;
    if(CurrentValue == 0){
      this.boxes = this.DigitalMarketingSlides;
    }else if(CurrentValue == 1){
      this.boxes = this.TechnologySlides;
    }else if(CurrentValue == 2){
      this.boxes = this.FintechSlides;
    }
    this.initialSlide(0);
  }
  initialSlide(slidenumber : number) {
    this.currentImage = this.boxes[slidenumber].image;
    this.currentText = this.boxes[slidenumber].description;
    this.currentHeading = this.boxes[slidenumber].heading;
    this.currentBenefits = this.boxes[slidenumber].benefits;
    this.currentBackground = this.boxes[slidenumber].currentBackground;
  }


  prevSlide() {
    this.currentIndex = (this.currentIndex - 1 + this.boxes.length) % this.boxes.length;
    this.updateSlide();
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.boxes.length;
    this.updateSlide();
  }
  updateSlide() {
    this.currentImage = this.boxes[this.currentIndex].image;
    this.currentText = this.boxes[this.currentIndex].description;
    this.currentHeading = this.boxes[this.currentIndex].heading;
    this.currentBenefits = this.boxes[this.currentIndex].benefits;
    this.currentBackground = this.boxes[this.currentIndex].currentBackground;
  }
}
